import { put, takeLatest } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import { fetchPlanConfigSuccess , fetchPlanConfigFailure  } from '../actions';
import LimitationTypes from '../types';


const { SAFBILLING_BASE_URL } = urls || {};

function* fetchPlanConfig({data}) {
  const {orgId} = data
  const url = `${SAFBILLING_BASE_URL}/api/plans/697a62a1-73ac-4be9-9e4e-a2abe01e7a42/plan-configurations/${orgId}`;
  const response = yield request({
    method: 'get',
    url,
  });


  if (response.success) {
    yield put(fetchPlanConfigSuccess(response?.raw));

  } else {
    yield put(fetchPlanConfigFailure('An error occured. Please reload the page to try again.'));
  }
}


export function* onGetPlanConfig() {
  yield takeLatest(
    LimitationTypes.FETCH_PLANCONFIG_START,
    fetchPlanConfig
  );
}
